module.exports = __webpack_public_path__ + "static/media/gordonsmit.6ea1b2f4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/gordonsmit.webp
// module id = 796
// module chunks = 0